import * as React from 'react'
import { connect } from 'react-redux'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionList } from 'components/ActionList'
import Box, { BoxType } from 'components/Box'
import { Button, TYPE } from 'components/Button'
import { Grid, GridGap } from 'components/Grid'
import Heading from 'components/Heading'
import Hero from 'components/Hero'
import { HeroType } from 'components/Hero/Hero'
import Icon from 'components/Icon'
import { InfoBox, InfoBoxItem } from 'components/InfoBox/InfoBox'
import { List, ListItem } from 'components/List'
import ListHeader from 'components/ListHeader'
import Section, {
  SectionColors,
  SectionType,
  Size,
} from 'components/Section/Section'
import Style from 'components/Style'
import { Timeline, TimelineBox, TimelineItem } from 'components/Timeline'
import { getCdnUrl } from '../../data/api/cdn'
import { ContentProps, EntryProps } from '../../data/entries/types'
import { inControlOptions } from '../../data/models/funnelOrder/days'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import { Theme } from '../../data/models/funnelOrder/theme'
import { SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { FunnelStep } from '../../data/ui'
import Calendar from '../../elements/Calendar'
import FlyIncludedCitiesCheckbox from '../../elements/excluded/FlyIncludedCitiesCheckbox'
import Flipclock from '../../elements/Flipclock'
import FunnelFooter from '../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../elements/FunnelBreadcrumbs'
import GiftcardModal from '../../elements/modals/GiftcardModal'
import PersonModal from '../../elements/modals/PersonModal'
import { getNameWithTheme, getParamsWithTheme } from '../../routing/links'
import Airport from '../funnel/customise/options/airport'
import Days from '../funnel/customise/options/days'
import LockedDestination from '../funnel/customise/options/lockedDestination'
import People from '../funnel/customise/options/people'
import RoomType from '../funnel/customise/options/roomType'
import { QueryKey } from '../funnel/customise/wrapper'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../funnel/customise/wrapperFunction'
import { LoaderPage } from '../loader'
import DisplayContent from '../shared/content'
import Page from '../shared/page_wrapper'
import BasicInfo from './components/basicInfo'
import HowItWorks from './components/entries/howItWorks'
import FAQ from './components/faq'

interface EscapeRoomProps extends EntryProps {
  theme: Theme
  total: number
  patternImage: string
  country: SiteCountry
  destination: destinationEnum
}

class EscapeTourPage extends React.Component<
  EscapeRoomProps & CustomiseWrapperInnerProps
> {
  private infoSection?: HTMLDivElement
  private detailsSection?: HTMLDivElement

  public render() {
    const { entry, match, prices, airports, destination } = this.props

    if (entry.page === undefined) {
      throw new Error('No page properties')
    }

    const isNextStepEnabled = this.isNextStepEnabled()

    return (
      <Page
        match={match}
        page={entry.page.name}
        color={entry.colour}
        navBarType="funnel"
        navBarOverrideColour={
          entry.page.style ? entry.page.style.navbarColor : undefined
        }
        navFooter
        whiteBackground
      >
        <Hero
          blurMobile
          type={HeroType.flavourEntry}
          headingColor={
            entry.page.style ? entry.page.style.headingColor : undefined
          }
          headingText={
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          }
          subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
          src={entry.page.photos.src}
          src1024={entry.page.photos.src1024}
          src1280={entry.page.photos.src1280}
          src1600={entry.page.photos.src1600}
          src1920={entry.page.photos.src1920}
        >
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          </Heading>
          <InfoBox>
            <InfoBoxItem
              icon={SRPRS.calendarColored()}
              firstLine={
                <DisplayContent contentKey="1-info-top">3 - 14</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="1-info-bottom">
                  Dagen
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={
                entry.theme === Theme.fly
                  ? SRPRS.aeroplaneColored
                  : SRPRS.carColored
              }
              firstLine={
                <DisplayContent contentKey="2-info-top">
                  destination
                </DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="2-info-bottom">
                  unknown
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.mapMarkerColored}
              iconProps={{
                width: '37',
                height: '37',
                viewBox: '0 0 37 41',
                fill: 'none',
              }}
              firstLine={
                <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="3-info-bottom">
                  Europa
                </DisplayContent>
              }
            />
          </InfoBox>
        </Hero>
        <BasicInfo
          type={SectionType.transparentWhite}
          detailsScroll={this.handleDetailsScroll}
          infoScroll={this.handleInfoScroll}
          nrItems={5}
        />
        <Section
          type={SectionType.white}
          size={Size.m}
          noBottomPadding
          decorationImages={[
            {
              width: 456,
              src: getCdnUrl(`pink-bg-pattern-right.png`),
              right: 0,
              top: -300,
              desktopOnly: true,
              isCovered: true,
            },
            {
              width: 300,
              src: getCdnUrl(`pink-bg-pattern-left.png`),
              left: 0,
              top: 360,
              desktopOnly: true,
            },
          ]}
        >
          <div ref={this.setDetailsRef} />
          <Section
            type={SectionType.solidLightPink}
            size={Size.s}
            color={SectionColors.lightTomato}
          >
            {entry.expiry && (
              <TimelineBox>
                <Box type={BoxType.fullWidthMobile}>
                  <Style margin={[[40, 40, 10, 40]]}>
                    <Heading
                      level={3}
                      subHeading={
                        <DisplayContent contentKey="box-sub-heading">
                          box-sub-heading
                        </DisplayContent>
                      }
                    >
                      <DisplayContent contentKey="box-heading">
                        box-heading
                      </DisplayContent>
                    </Heading>
                    <p>
                      <DisplayContent contentKey="box-blurb">
                        box-blurb
                      </DisplayContent>
                    </p>

                    <Flipclock timestamp={entry.expiry} />
                  </Style>
                </Box>
              </TimelineBox>
            )}
            <Style margin={[[40, 0, 20, 0]]}>
              <Timeline direction="vertical" numbers>
                <TimelineItem>
                  <Heading level={3}>
                    <DisplayContent contentKey="exclude-cities-heading">
                      Which cities will it be?
                    </DisplayContent>
                  </Heading>
                  <p>
                    <DisplayContent contentKey="exclude-cities-subheading">
                      Do you just strike 2 out of contention of all 5? You
                      decide.
                    </DisplayContent>
                  </p>
                  <FlyIncludedCitiesCheckbox
                    destination={destination}
                    max={3}
                  />
                </TimelineItem>
                <TimelineItem>
                  <ActionList>
                    <People />
                    <Days options={inControlOptions} />
                    <RoomType />
                    <Airport {...{ airports, noTimes: true }} />
                    <LockedDestination />
                  </ActionList>
                </TimelineItem>
                <TimelineItem>
                  <Box fullWidthMobile>
                    <Calendar
                      actionList
                      hideTrigger
                      showCheapest={true}
                      prices={prices}
                    />
                  </Box>
                </TimelineItem>
              </Timeline>
            </Style>
            <PersonModal />
          </Section>
        </Section>
        <FunnelFooter
          hideTotalWhenDisabled
          nextStepNo={2}
          nextStepLink={getNameWithTheme('extras')}
          nextStepLinkParams={getParamsWithTheme()}
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          stickyStop
          nextStepDisabled={!isNextStepEnabled}
        />
        <GiftcardModal />
        <div ref={this.setInfoRef} />
        {this.renderFlavourBox(entry.page.content)}
        {this.renderHowItWorks()}
        <Section type={SectionType.white} size={Size.m}>
          <ListHeader noMarginBottom>
            <Button
              cutOff="none"
              type={TYPE.plain}
              onClick={this.handleDetailsScroll}
            >
              <DisplayContent contentKey="boek-direct" edit={true}>
                Boek direct
              </DisplayContent>
            </Button>
          </ListHeader>
        </Section>
        <FAQ size={Size.m} />
      </Page>
    )
  }

  private renderHowItWorks() {
    return (
      <HowItWorks
        boxTypeColor={BoxType.tomatoHeaders}
        backgroundImageLink={'bucketlist-heading-bg.jpg'}
      />
    )
  }

  private renderFlavourBox(content?: ContentProps) {
    const renderExplain = (leftOrRight: 'left' | 'right') => {
      let length = 5
      if (content) {
        if (leftOrRight === 'left' && content.explainLeft) {
          length = content.explainLeft
        }
        if (leftOrRight === 'right' && content.explainRight) {
          length = content.explainRight
        }
      }
      const output = []
      for (let i = 1; i <= length; i++) {
        output.push(
          <ListItem dash key={i}>
            <DisplayContent contentKey={`explain-${leftOrRight}-text-${i}`}>
              {`explain-${leftOrRight}-text-${i}`}
            </DisplayContent>
          </ListItem>,
        )
      }
      return output
    }

    return (
      <Section
        type={SectionType.photo}
        size={Size.m}
        src={{
          blurMobile: false,
          src: getCdnUrl('escape-faq-bg-768.jpg'),
          src1024: getCdnUrl('escape-faq-bg-1024.jpg'),
          src1280: getCdnUrl('escape-faq-bg-1280.jpg'),
          src1600: getCdnUrl('escape-faq-bg-1600.jpg'),
          src1920: getCdnUrl('escape-faq-bg-1920.jpg'),
        }}
      >
        <Grid
          nrCols={[1, 2]}
          rowGap={[GridGap.m]}
          className={'grid-white-text'}
        >
          <div>
            <Heading level={4}>
              <DisplayContent contentKey="explain-left-heading">
                What we do for you
              </DisplayContent>
            </Heading>
            <List>{renderExplain('left')}</List>
          </div>
          <div>
            <Heading level={4}>
              <DisplayContent contentKey="explain-right-heading">
                What you need to arrange yourself
              </DisplayContent>
            </Heading>
            <List>{renderExplain('right')}</List>
          </div>
        </Grid>
      </Section>
    )
  }

  private isNextStepEnabled(): boolean {
    const { total } = this.props
    return !isNaN(total)
  }

  private setInfoRef = (ref: HTMLDivElement) => {
    this.infoSection = ref
  }

  private setDetailsRef = (ref: HTMLDivElement) => {
    this.detailsSection = ref
  }

  private handleInfoScroll = () => {
    if (this.infoSection) {
      this.infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private handleDetailsScroll = () => {
    if (this.detailsSection) {
      this.detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}

const ConnectedEscapeRoomPage = connect((state: AppState) => ({
  theme: state.funnelOrder.theme,
  patternImage: state.page.patternImage,
  total: state.funnelOrder.total,
  destination: state.funnelOrder.destination,
  country: state.locale.country,
}))(EscapeTourPage)

export default withAirportsAndPrices<EntryProps>(ConnectedEscapeRoomPage, [
  QueryKey.month,
  QueryKey.year,
])
